import { IExplainedScoreMaybe } from 'autogen/swagger/all';
import React from 'react';
import ExplainedScore from './ExplainedScore';

export default function ProductItemDebugger({ explainedScore }: { explainedScore?: IExplainedScoreMaybe }) {
    return <>{explainedScore && <ExplainedScore model={explainedScore} />}</>;
}
